import { render, staticRenderFns } from "./VerifyView.vue?vue&type=template&id=0bfdcc71&scoped=true"
import script from "./VerifyView.vue?vue&type=script&lang=js"
export * from "./VerifyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfdcc71",
  null
  
)

export default component.exports